import { useContext } from 'react';
import { Alert } from '@mui/joy';
import { motion, AnimatePresence } from 'framer-motion';
import { AppContext } from '../context';

export default function Toast() {
    const { toast } = useContext(AppContext);
    
    return (
        <AnimatePresence>
            {toast && (
                <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0,  scale: 1    }}
                    exit={{   opacity: 0, y: 20,  scale: 0.95 }}
                    transition={{ duration: 0.25 }}
                    style={{
                        position: 'fixed', bottom: 24, left: '3%',
                        transform: 'translateX(-50%)', zIndex: 9999,
                        whiteSpace: 'nowrap',
                    }}
                >
                    <Alert
                        color={toast?.color || 'success'}
                        variant="solid"
                        sx={{
                            borderRadius: 'var(--joy-radius-lg)',
                            px: 3, py: 1.5,
                            fontSize: 13, fontWeight: 600,
                            boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                        }}
                    >
                        {toast?.msg}
                    </Alert>
                </motion.div>
            )}
        </AnimatePresence>
    );
}